export default __webpack_public_path__ + "static/media/nibi icon B.75d6dfdb.svg";